module.exports = __webpack_public_path__ + "img/banner.276a7b00.png";